import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Filter, FilterCategory, FilterList, FilterRequest } from 'models/filter.model';
import { LicenseClass } from 'models/license-class.model';
import { SearchLicense } from 'models/search-license.model';
import { State } from 'models/state.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FilterService } from 'services/filter.service';
import { SharedService } from 'services/shared.service';
import { ValidatorHelper } from '../../custom-validators/validators.helper';
import { SearchAppointment } from 'models/search-appointment.modal';
import { TagList } from 'models/tag.model';
import { SearchProducerRequest } from '../../../models/packages/searchProducerRequest.model';
import { Location } from '@angular/common';
import { RoleService } from '../../../services/role.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  isSavePopup: boolean = false;
  isDeletePopup: boolean = false;
  tenantTypeId = localStorage['tenantTypeId'];
  expiryDays = localStorage["expiryDays"];
  tenantId = Number(localStorage.getItem('tenantId'));
  userId = Number(localStorage.getItem('userId'));

  @Input() filterCategory: number;
  @Input() dropdownSettingState: IDropdownSettings;
  @Input() states: any[];
  @Input() dropdownSettingLicenseClass: IDropdownSettings;
  @Input() licenseClasses: any[];
  @Input() dropdownSettingTag: IDropdownSettings;
  @Input() tags: any[];
  @Input() branchList: any[];
  @Input() licenseStatusList: any[];
  @Input() expiryInData: any[];
  @Input() filterList: FilterList[] = [];
  @Input() departmentList: any[];
  @Input() tenantStatusList: any[];
  @Input() expireIn: any[];
  @Input() residentTypeList: any[];
  @Input() userTypeList: any[];

  @Input() dropdownSettingActiveContactList: IDropdownSettings;
  @Input() activeContactList: any[];
  @Input() dropdownSettingCarrierList: IDropdownSettings;
  @Input() carrierList: any[];
  @Input() lineOfBusinessList: any[];

  @Input() selectedStates: State[];
  @Input() selectedLicenseClasses: LicenseClass[];
  @Input() selectedTags: TagList[];
  @Input() selectedBranchId: number = 0;
  @Input() selectedStatus: string = '';
  @Input() selectedExpireIn: number = 0;
  @Input() selectedFilter: number;
  @Input() selectedFilterName: string = '';
  @Input() selectedResidentTypeCode: string = '';
  @Input() selectedNPNType: string = '';
  @Input() selectedContactList: any[];
  @Input() selectedCarrierList: any[];
  //@Input() selectedCarrierId: number = 0;
  @Input() selectedLineOfBusinessCarrierId: number = 0;

  @Input() branchId: number = 0;
  @Input() departmentId: number = 0;
  @Input() tenantStatusId: number = 0;

  @Input() dropdownSettingAppointType: IDropdownSettings;
  //@Input() dropdownSettingTag: IDropdownSettings;
  @Input() appointmentTypeList: any;
  @Input() selectedAppointmentTypeList: any;

  @Output() filterCriteriaChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveFilter: EventEmitter<any> = new EventEmitter<any>();

  saveFilterForm: FormGroup;
  filter: Filter = {} as Filter;
  tempFilterList: FilterList[] = [];
  // filterList: FilterList[] = [];
  // selectedFilter: number;
  filterRequest: FilterRequest = {} as FilterRequest;
  searchLicenseModel: SearchLicense = {} as SearchLicense;
  searchAppointmentModel: SearchAppointment = {} as SearchAppointment;
  searchContactModel: any = {};
  loggedinUserRole = localStorage["userRole"]
  isLoad: boolean = false;
  status: string;

  isDisabled: boolean = false;
  IndividualBulkLicenseRenewal = FilterCategory.IndividualBulkLicenseRenewal;
  filterCategoryProducer = FilterCategory.Producers;

  @Input() dropdownSettingResidentState: IDropdownSettings;
  @Input() residentStateList: any[];
  @Input() selectedResidentStates: State[];
  isContactUser: boolean = false;
  isMGAUser: boolean = false;

  constructor(private sharedService: SharedService,
    private location: Location,
    private filterService: FilterService,
    private modalService: NgbModal,
    private roleService: RoleService) { }

  ngOnInit(): void {
    this.saveFilterForm = this.bindFormGroup();
    this.tempFilterList = this.filterList;
    this.isContactUser = this.roleService.isContactUser;
     this.isMGAUser  = this.roleService.isMGAUser;
    // Producers
    if (this.filterCategory == 1) {
      this.status = 'All'
    }
    // Licenses
    else if (this.filterCategory == 3) {
      this.status = 'Appointed'
    }
    else if (this.filterCategory == 4) {
      this.status = null
    }

    // Appointments
    else {
      this.status = 'Active';
    }

    if (this.selectedFilter != undefined && this.filterList != undefined) {
      const filterData = this.filterList.find(obj => obj.filterId === this.selectedFilter);
      if (filterData && filterData.ownerUserId != this.userId) {
        this.isDisabled = true;
      }
    }
  }

  @HostListener('window:popstate', ['$event'])
  public onPopState(event: PopStateEvent) {
    this.modalService.dismissAll();
    event.preventDefault();
    event.stopPropagation();
    event.cancelBubble = true;
  }

  bindFormGroup(): FormGroup {
    return new FormGroup({
      filterName: new FormControl(null, [Validators.required]),
      default: new FormControl(this.loggedinUserRole != 'contact' ? false : true),
      public: new FormControl(false)
    });
  }

  clearFilter() {
    this.selectedFilter = null;
    const locState = this.location.getState();
    if (locState) {
      delete locState['tag'];
      delete locState['carrierList'];
    }

    if (this.filterCategory == 1) {
      this.departmentId = 0;
      this.branchId = 0;
      this.tenantStatusId = 0;
      this.selectedTags = [];
      this.selectedResidentStates = [];
      this.selectedFilterName = '';
    }
    else {
      this.selectedStates = [];
      this.selectedLicenseClasses = [];
      this.selectedTags = [];
      this.selectedAppointmentTypeList = [];
      this.selectedBranchId = 0;
      this.selectedStatus = this.status;
      this.selectedExpireIn = 0;
      this.selectedFilterName = '';
      this.isDisabled = false;
      this.selectedResidentTypeCode = 'null';
      this.selectedNPNType = 'null';
      this.selectedContactList = [];
      this.selectedCarrierList = [];
      //this.selectedCarrierId = 0;
      this.selectedLineOfBusinessCarrierId = 0;
    }
  }

  applyFilter(closePanel: boolean = false) {
    if (arraysEqual(this.tempFilterList, this.filterList) == false)
      this.isLoad = true;

    if (this.filterCategory == 1) {
      const filterCriteria = {
        filter: this.selectedFilter,
        filterName: this.selectedFilterName,
        isLoad: this.isLoad,
        branchId: this.branchId == null ? 0 : this.branchId,
        departmentId: this.departmentId == null ? 0 : this.departmentId,
        tenantStatusId: this.tenantStatusId == null ? 0 : this.tenantStatusId,
        tags: this.selectedTags,
        residentStates: this.selectedResidentStates,
        closePanel: closePanel
      };

      this.filterCriteriaChange.emit(filterCriteria);
    }
    else {
      const filterCriteria = {
        filter: this.selectedFilter,
        filterName: this.selectedFilterName,
        isLoad: this.isLoad,
        states: this.selectedStates,
        licenseClasses: this.selectedLicenseClasses,
        tags: this.selectedTags,
        appointmentTypes: this.selectedAppointmentTypeList,
        branchId: this.selectedBranchId,
        status: this.selectedStatus,
        expireIn: this.selectedExpireIn,
        residentTypeCode: this.selectedResidentTypeCode,
        npnType: this.selectedNPNType,
        contactList: this.selectedContactList,
        carrierList: this.selectedCarrierList,
        //carrierId: this.selectedCarrierId,
        lineOfBusinessCarrierId: this.selectedLineOfBusinessCarrierId,
        closePanel: closePanel
      };

      this.filterCriteriaChange.emit(filterCriteria);
    }
  }

  openSaveFilterPopup() {
    this.isSavePopup = true;
    this.saveFilterForm = this.bindFormGroup();
  }

  closeSavePopup() {
    this.isSavePopup = false;
  }

  saveFilterChanges() {
    this.saveFilterForm.markAllAsTouched();
    if (this.saveFilterForm.valid) {
      this.isSavePopup = false;

      // Save filters to service        
      this.filter.TenantId = this.tenantId;
      this.filter.OwnerUserId = this.userId;
      this.filter.FilterCategoryId = this.filterCategory;
      this.filter.Name = this.saveFilterForm.value.filterName.trim();
      this.filter.Default = this.saveFilterForm.value.default;
      this.filter.Public = this.saveFilterForm.value.public;

      let criteria = null;

      if (this.filterCategory == 1) {
        criteria = this.setContactCriteria();
      }
      else if (this.filterCategory == 2 || this.filterCategory == 4) {
        criteria = this.setLicensesCriteria();
      }
      else if (this.filterCategory == 3) {
        criteria = this.setAppointmentCriteria();
      }

      this.filter.CreatedBy = this.userId;

      if ((this.filterCategory == 1) && ((criteria.tenantStatusId == null || criteria.tenantStatusId == undefined || criteria.tenantStatusId == 0)
        && (criteria.branchId == null || criteria.branchId == undefined || criteria.branchId == 0)
        && (criteria.departmentId == null || criteria.departmentId == undefined || criteria.departmentId == 0)) && (criteria.tags == '') && (criteria.residentStates == '')) {
        this.sharedService.showToastMessage("No filter selected. Please ensure that at least one filter is selected before saving.");
      }
      else if ((this.filterCategory == 2) && (criteria.states == '') && (criteria.licenseClass == '') && (criteria.tags == '')
        && (criteria.branchId == null || criteria.branchId == undefined)
        && (criteria.status == null || criteria.status == undefined || criteria.status == '')
        && (criteria.expireIn == null || criteria.expireIn == undefined)
        && (criteria.residentTypeCode == null || criteria.residentTypeCode == undefined || criteria.residentTypeCode == '')
        && (criteria.npnType == null || criteria.npnType == undefined || criteria.npnType == '')) {
        this.sharedService.showToastMessage("No filter selected. Please ensure that at least one filter is selected before saving.");
      }
      else if ((this.filterCategory == 4) && (criteria.states == '') && (criteria.licenseClass == '')
        && (criteria.branchId == null || criteria.branchId == undefined)
        && (criteria.status == null || criteria.status == undefined || criteria.status == '')
        && (criteria.expireIn == null || criteria.expireIn == undefined)) {
        this.sharedService.showToastMessage("No filter selected. Please ensure that at least one filter is selected before saving.");
      }
      else if ((this.filterCategory == 3) && (criteria.states == '') && (criteria.appointmentTypes == '')
        && (criteria.tags == '')
        && (criteria.branchId == null || criteria.branchId == undefined)
        && (criteria.status == null || criteria.status == undefined || criteria.status == '')
        && (criteria.expireIn == null || criteria.expireIn == undefined)
        && (criteria.contactList == '')
        && (criteria.carrierList == '')
        //&& (criteria.carrierId == null || criteria.carrierId == undefined)
        && (criteria.lineOfBusinessCarrierId == null || criteria.lineOfBusinessCarrierId == undefined)) {
        this.sharedService.showToastMessage("No filter selected. Please ensure that at least one filter is selected before saving.");
      }
      else {
        this.filter.Criteria = JSON.stringify(criteria);

        this.filterService.insertFilter(this.filter).subscribe(
          (response) => {
            if (response && response > 0) {
              this.sharedService.showToastMessage("Filter saved successfully.");
              this.loadFilters("insert", response);
            }
          },
          (error) => {
            // Handle error           
            this.sharedService.showToastMessage("Unable to save the filter. Please try again.");
          }
        );

      }
    }
  }

  updateFilter() {
    // Update filters to service        
    this.filter.FilterId = this.selectedFilter;
    this.filter.TenantId = this.tenantId;

    let criteria = null;

    if (this.filterCategory == 1) {
      criteria = this.setContactCriteria();
    }
    else if (this.filterCategory == 2 || this.filterCategory == 4) {
      criteria = this.setLicensesCriteria();
    }
    else if (this.filterCategory == 3) {
      criteria = this.setAppointmentCriteria();
    }

    this.filter.UpdatedBy = this.userId;

    if ((this.filterCategory == 1) && ((criteria.tenantStatusId == null || criteria.tenantStatusId == undefined || criteria.tenantStatusId == '') && (criteria.tags == null || criteria.tags == undefined || criteria.tags == '')
      && (criteria.residentStates == null || criteria.residentStates == undefined || criteria.residentStates == '')
      && (criteria.branchId == null || criteria.branchId == undefined) && (criteria.departmentId == null || criteria.departmentId == undefined))) {
      this.sharedService.showToastMessage("Please ensure that at least one filter is selected for Status, Branch, or Department.");
    }
    else
      if ((this.filterCategory == 2) && (criteria.states == '') && (criteria.licenseClass == '') && (criteria.tags == '')
        && (criteria.branchId == null || criteria.branchId == undefined)
        && (criteria.status == null || criteria.status == undefined || criteria.status == '')
        && (criteria.expireIn == null || criteria.expireIn == undefined)
        && (criteria.residentTypeCode == null || criteria.residentTypeCode == undefined || criteria.residentTypeCode == '')
        && (criteria.npnType == null || criteria.npnType == undefined || criteria.npnType == '')) {
        this.sharedService.showToastMessage("Please ensure that at least one filter is selected for State, License Class, Branch, Status, or Expires In.");
      }
      else if ((this.filterCategory == 4) && (criteria.states == '') && (criteria.licenseClass == '')
        && (criteria.branchId == null || criteria.branchId == undefined)
        && (criteria.status == null || criteria.status == undefined || criteria.status == '')
        && (criteria.expireIn == null || criteria.status == undefined)
        && (criteria.npnType == null || criteria.npnType == undefined || criteria.npnType == '')) {
        this.sharedService.showToastMessage("Please ensure that at least one filter is selected for State, License Class, Branch, or Expires In.");
      }
      else if ((this.filterCategory == 3) && (criteria.states == '') && (criteria.appointmentTypes == '')
        && (criteria.tags == '')
        && (criteria.branchId == null || criteria.branchId == undefined)
        && (criteria.status == null || criteria.status == undefined || criteria.status == '')
        && (criteria.expireIn == null || criteria.status == undefined)
        && (criteria.contactList == '')
        && (criteria.carrierList == '')
        //&& (criteria.carrierId == null || criteria.carrierId == undefined)
        && (criteria.lineOfBusinessCarrierId == null || criteria.lineOfBusinessCarrierId == undefined)
      ) {
        this.sharedService.showToastMessage("Please ensure that at least one filter is selected for State, Appointment Type, Branch, Status, or Expires In.");
      }
      else {

        this.filter.Criteria = JSON.stringify(criteria);

        this.filterService.updateFilter(this.filter).subscribe(
          (response) => {
            // Handle successful response
            if (response && response > 0) {
              this.sharedService.showToastMessage("Filter updated successfully.");
            }
            else {
              this.sharedService.showToastMessage("Oops! Something went wrong. ");
            }
            this.loadFilters("update", this.filter.FilterId);
          },
          (error) => {
            // Handle error         
            this.sharedService.showToastMessage("Oops! Something went wrong. Please try again");
          }
        );

      }
  }

  setLicensesCriteria() {
    var stateIds = null;
    if (this.selectedStates && this.selectedStates.length > 0) {
      stateIds = this.selectedStates.map(function (val) {
        return val.stateId
      }).join(',');
    }

    var licenseClassCode = null;
    if (this.selectedLicenseClasses && this.selectedLicenseClasses.length > 0) {
      licenseClassCode = this.selectedLicenseClasses.map(function (val) {
        return val.licenseClassCode
      }).join(',');
    }

    var tagIds = null;
    if (this.selectedTags && this.selectedTags.length > 0) {
      tagIds = this.selectedTags.map(function (val) {
        return val.tagId
      }).join(',');
    }

    this.searchLicenseModel.states = stateIds;
    this.searchLicenseModel.licenseClass = licenseClassCode;
    this.searchLicenseModel.tags = tagIds;
    this.searchLicenseModel.branchId = this.selectedBranchId;
    this.searchLicenseModel.status = this.selectedStatus;
    this.searchLicenseModel.expireIn = this.selectedExpireIn;
    this.searchLicenseModel.residentTypeCode = this.selectedResidentTypeCode;
    this.searchLicenseModel.npnType = this.selectedNPNType;

    const criteria = { states: '', licenseClass: '', tags: '', branchId: null, status: '', expireIn: null, residentTypeCode: null, npnType: null };

    if (this.searchLicenseModel.states != null && this.searchLicenseModel.states != undefined && this.searchLicenseModel.states != '') {
      criteria.states = this.searchLicenseModel.states;
    }

    if (this.searchLicenseModel.licenseClass != null && this.searchLicenseModel.licenseClass != undefined && this.searchLicenseModel.licenseClass != '') {
      criteria.licenseClass = this.searchLicenseModel.licenseClass;
    }

    if (this.searchLicenseModel.tags != null && this.searchLicenseModel.tags != undefined && this.searchLicenseModel.tags != '') {
      criteria.tags = this.searchLicenseModel.tags;
    }

    if (this.searchLicenseModel.branchId != null && this.searchLicenseModel.branchId != undefined) {
      criteria.branchId = this.searchLicenseModel.branchId;
    }

    if (this.searchLicenseModel.status != null && this.searchLicenseModel.status != undefined && this.searchLicenseModel.status != '') {
      criteria.status = this.searchLicenseModel.status;
    }

    if (this.searchLicenseModel.expireIn != null && this.searchLicenseModel.expireIn != undefined) {
      criteria.expireIn = this.searchLicenseModel.expireIn;
    }

    if (this.searchLicenseModel.residentTypeCode != null && this.searchLicenseModel.residentTypeCode != undefined) {
      criteria.residentTypeCode = this.searchLicenseModel.residentTypeCode;
    }

    if (this.searchLicenseModel.npnType != null && this.searchLicenseModel.npnType != undefined) {
      criteria.npnType = this.searchLicenseModel.npnType;
    }

    return criteria;
  }

  setAppointmentCriteria() {
    var stateIds = null;
    if (this.selectedStates && this.selectedStates.length > 0) {
      stateIds = this.selectedStates.map(function (val) {
        return val.stateId
      }).join(',');
    }

    var AppointmentTypeId = null;
    if (this.selectedAppointmentTypeList && this.selectedAppointmentTypeList.length > 0) {
      AppointmentTypeId = this.selectedAppointmentTypeList.map(function (val) {
        return val.appointmentTypeId
      }).join(',');
    }

    var tagIds = null;
    if (this.selectedTags && this.selectedTags.length > 0) {
      tagIds = this.selectedTags.map(function (val) {
        return val.tagId
      }).join(',');
    }

    var contactIds = null;
    if (this.selectedContactList && this.selectedContactList.length > 0) {
      contactIds = this.selectedContactList.map(function (val) {
        return val.userId
      }).join(',');
    }

    var carrierIds = null;
    if (this.selectedCarrierList && this.selectedCarrierList.length > 0) {
      carrierIds = this.selectedCarrierList.map(function (val) {
        return val.carrierId
      }).join(',');
    }

    this.searchAppointmentModel.states = stateIds;
    this.searchAppointmentModel.appointmentTypes = AppointmentTypeId;
    this.searchAppointmentModel.tags = tagIds;
    this.searchAppointmentModel.branchId = this.selectedBranchId;
    this.searchAppointmentModel.status = this.selectedStatus;
    this.searchAppointmentModel.expireIn = this.selectedExpireIn;
    this.searchAppointmentModel.npnType = this.selectedNPNType;
    this.searchAppointmentModel.contactList = contactIds;
    this.searchAppointmentModel.carrierList = carrierIds;
    this.searchAppointmentModel.lineOfBusinessCarrierId = this.selectedLineOfBusinessCarrierId;

    //const criteria = { states: '', appointmentTypes: '', tags: '', branchId: null, status: '', expireIn: null, npnType: null, contactList: '', carrierId: null, lineOfBusinessCarrierId: null };
    const criteria = { states: '', appointmentTypes: '', tags: '', branchId: null, status: '', expireIn: null, npnType: null, contactList: '', carrierList: '', lineOfBusinessCarrierId: null };

    if (this.searchAppointmentModel.states != null && this.searchAppointmentModel.states != undefined && this.searchAppointmentModel.states != '') {
      criteria.states = this.searchAppointmentModel.states;
    }

    if (this.searchAppointmentModel.appointmentTypes != null && this.searchAppointmentModel.appointmentTypes != undefined && this.searchAppointmentModel.appointmentTypes != '') {
      criteria.appointmentTypes = this.searchAppointmentModel.appointmentTypes;
    }

    if (this.searchAppointmentModel.tags != null && this.searchAppointmentModel.tags != undefined && this.searchAppointmentModel.tags != '') {
      criteria.tags = this.searchAppointmentModel.tags;
    }

    if (this.searchAppointmentModel.branchId != null && this.searchAppointmentModel.branchId != undefined) {
      criteria.branchId = this.searchAppointmentModel.branchId;
    }

    if (this.searchAppointmentModel.status != null && this.searchAppointmentModel.status != undefined && this.searchAppointmentModel.status != '') {
      criteria.status = this.searchAppointmentModel.status;
    }

    if (this.searchAppointmentModel.expireIn != null && this.searchAppointmentModel.expireIn != undefined) {
      criteria.expireIn = this.searchAppointmentModel.expireIn;
    }

    if (this.searchAppointmentModel.npnType != null && this.searchAppointmentModel.npnType != undefined) {
      criteria.npnType = this.searchAppointmentModel.npnType;
    }

    if (this.searchAppointmentModel.contactList != null && this.searchAppointmentModel.contactList != undefined && this.searchAppointmentModel.contactList != '') {
      criteria.contactList = this.searchAppointmentModel.contactList;
    }

    if (this.searchAppointmentModel.carrierList != null && this.searchAppointmentModel.carrierList != undefined && this.searchAppointmentModel.carrierList != '') {
      criteria.carrierList = this.searchAppointmentModel.carrierList;
    }
    //if (this.searchAppointmentModel.carrierId != null && this.searchAppointmentModel.carrierId != undefined) {
    //  criteria.carrierId = this.searchAppointmentModel.carrierId;
    //}

    if (this.searchAppointmentModel.lineOfBusinessCarrierId != null && this.searchAppointmentModel.lineOfBusinessCarrierId != undefined) {
      criteria.lineOfBusinessCarrierId = this.searchAppointmentModel.lineOfBusinessCarrierId;
    }

    return criteria;
  }

  setContactCriteria() {

    var tagIds = null;
    if (this.selectedTags && this.selectedTags.length > 0) {
      tagIds = this.selectedTags.map(function (val) {
        return val.tagId
      }).join(',');
    }

    var residentStates = null;
    if (this.selectedResidentStates && this.selectedResidentStates.length > 0) {
      residentStates = this.selectedResidentStates.map(function (val) {
        return val.stateCode
      }).join(',');
    }

    this.searchContactModel.branchId = this.branchId;
    this.searchContactModel.departmentId = this.departmentId;
    this.searchContactModel.tenantStatusId = this.tenantStatusId;
    this.searchContactModel.tags = tagIds;
    this.searchContactModel.residentStates = residentStates;

    const criteria = { branchId: 0, departmentId: 0, tenantStatusId: 0, tags: '', residentStates: '' };

    if (this.searchContactModel.branchId != null && this.searchContactModel.branchId != undefined && this.searchContactModel.branchId != 0) {
      criteria.branchId = this.searchContactModel.branchId;
    }

    if (this.searchContactModel.departmentId != null && this.searchContactModel.departmentId != undefined && this.searchContactModel.departmentId != 0) {
      criteria.departmentId = this.searchContactModel.departmentId;
    }

    if (this.searchContactModel.tenantStatusId != null && this.searchContactModel.tenantStatusId != undefined && this.searchContactModel.tenantStatusId != 0) {
      criteria.tenantStatusId = this.searchContactModel.tenantStatusId;
    }

    if (this.searchContactModel.tags != null && this.searchContactModel.tags != undefined && this.searchContactModel.tags != '') {
      criteria.tags = this.searchContactModel.tags;
    }

    if (this.searchContactModel.residentStates != null && this.searchContactModel.residentStates != undefined && this.searchContactModel.residentStates != '') {
      criteria.residentStates = this.searchContactModel.residentStates;
    }

    return criteria;
  }

  onCheckboxChange(event) {
    if (event.target.name == "default") {
      if (event.target.checked == true) {
        this.saveFilterForm.get("public").setValue(false);
        this.saveFilterForm.get('public').disable();
      }
      else {
        this.saveFilterForm.get("public").setValue(false);
        this.saveFilterForm.get('public').enable();
      }
    }
    else if (event.target.name == "public") {
      if (event.target.checked == true) {
        this.saveFilterForm.get("default").setValue(false);
        this.saveFilterForm.get('default').disable();
      }
      else {
        this.saveFilterForm.get("default").setValue(false);
        this.saveFilterForm.get('default').enable();
      }
    }
  }

  loadFilters(operation: string, currentFilter: number) {
    //Fetch the stored filter category filter details       
    this.filterService.getFilters(this.filterCategory, this.tenantId, this.userId, false).subscribe(
      (response) => {
        // Handle successful response
        this.filterList = response;

        if (this.filterList && this.filterList.length > 0) {
          var foundDefaultFilter = this.filterList.find(obj => obj.default === true);

          //If default filter not found and user selected public or any other filter and apply the changes at that time checking filter available or not
          if ((operation == "insert" || operation == "update") && currentFilter != null) {
            foundDefaultFilter = this.filterList.find(obj => obj.filterId === currentFilter);
          }
          else if (foundDefaultFilter == undefined && this.selectedFilter != null) {
            foundDefaultFilter = this.filterList.find(obj => obj.filterId === this.selectedFilter);
          }

          if (foundDefaultFilter) {
            this.selectedFilter = foundDefaultFilter.filterId;

            if (this.selectedFilter) {
              const filterData = this.filterList.find(obj => obj.filterId === this.selectedFilter);

              if (filterData && filterData.criteria != null) {
                this.selectedFilterName = filterData.name;

                if (filterData.ownerUserId != this.userId) {
                  this.isDisabled = true;
                }
                else {
                  this.isDisabled = false;
                }

                const criteria = JSON.parse(filterData.criteria);

                //Set selectedTags variable to bind tag dropdown
                if (criteria.tags != null) {
                  const tagIdsArray: number[] = criteria.tags.split(',').map(id => parseInt(id.trim(), 10));

                  this.selectedTags = [];
                  tagIdsArray.forEach(id => {
                    const foundTag = this.tags.find(tag => tag.tagId === id);
                    if (foundTag) {
                      this.selectedTags.push(foundTag);
                    }
                  });
                }

                if (this.filterCategory == this.filterCategoryProducer) {

                  this.tenantStatusId = criteria.tenantStatusId;
                  this.branchId = criteria.branchId;
                  this.departmentId = criteria.departmentId;

                  if (criteria.residentStates != null) {
                    const residentStatesArray: number[] = criteria.residentStates.split(',').map(id => id);

                    this.selectedResidentStates = [];
                    residentStatesArray.forEach(id => {
                      const foundState = this.residentStateList.find(state => state.stateCode === id);
                      if (foundState) {
                        this.selectedResidentStates.push(foundState);
                      }
                    });
                  }
                }
                else {
                  //Set selectedStates variable to bind state dropdown
                  if (criteria.states != null) {
                    const stateIdsArray: number[] = criteria.states.split(',').map(id => parseInt(id.trim(), 10));

                    this.selectedStates = [];
                    stateIdsArray.forEach(id => {
                      const foundState = this.states.find(state => state.stateId === id);
                      if (foundState) {
                        this.selectedStates.push(foundState);
                      }
                    });
                  }

                  //Set selectedLicenseClasses variable to bind license class dropdown
                  if (criteria.licenseClass != null) {
                    const licenseClassCodesArray: string[] = criteria.licenseClass.split(',');

                    this.selectedLicenseClasses = [];
                    licenseClassCodesArray.forEach(code => {
                      const foundlicenseClass = this.licenseClasses.find(licenseclass => licenseclass.licenseClassCode === code);
                      if (foundlicenseClass) {
                        this.selectedLicenseClasses.push(foundlicenseClass);
                      }
                    });
                  }

                  if (criteria != undefined && criteria.appointmentTypes != null) {
                    const appointmentTypeIdsArray: number[] = criteria.appointmentTypes.split(',').map(id => parseInt(id.trim(), 10));

                    this.selectedAppointmentTypeList = [];
                    appointmentTypeIdsArray.forEach(id => {
                      const foundappointmentType = this.appointmentTypeList.find(appointmenttype => appointmenttype.appointmentTypeId === id);
                      if (foundappointmentType) {
                        this.selectedAppointmentTypeList.push(foundappointmentType);
                      }
                    });
                  }

                  this.selectedStatus = criteria.status == '' ? null : criteria.status;

                  this.selectedBranchId = criteria.branchId;

                  this.selectedExpireIn = criteria.expireIn;
                  this.selectedResidentTypeCode = criteria.residentTypeCode;
                  this.selectedNPNType = criteria.npnType;
                  //this.selectedContactId = criteria.contactId;

                  if (criteria.contactList != null) {
                    const contactIdsArray: number[] = criteria.contactList.split(',').map(id => parseInt(id.trim(), 10));

                    this.selectedContactList = [];
                    contactIdsArray.forEach(id => {
                      const foundContact = this.activeContactList.find(contact => contact.userId === id);
                      if (foundContact) {
                        this.selectedContactList.push(foundContact);
                      }
                    });
                  }

                  if (criteria.carrierList != null) {
                    const carrierIdsArray: number[] = criteria.carrierList.split(',').map(id => parseInt(id.trim(), 10));

                    this.selectedCarrierList = [];
                    carrierIdsArray.forEach(id => {
                      const foundCarrier = this.carrierList.find(carrier => carrier.carrierId === id);
                      if (foundCarrier) {
                        this.selectedCarrierList.push(foundCarrier);
                      }
                    });
                  }
                  //this.selectedCarrierId = criteria.carrierId;

                  this.selectedLineOfBusinessCarrierId = criteria.lineOfBusinessCarrierId;

                }
              }
            }
          }
          else {
            this.clearSelection();
          }
        }
        else {
          this.clearSelection();
        }
      },
      (error) => {
        // Handle error
        console.log(error);
      }
    );
  }

  clearSelection() {
    this.selectedFilter = null;
    this.selectedTags = [];
    if (this.filterCategory == this.filterCategoryProducer) {
      this.branchId = 0;
      this.departmentId = 0;
      this.tenantStatusId = 0;
      this.selectedResidentStates = [];
    } else {

      this.selectedStates = [];
      this.selectedLicenseClasses = [];
      this.selectedAppointmentTypeList = [];
      this.selectedBranchId = null;
      this.selectedStatus = this.status;
      this.selectedExpireIn = null;
      this.selectedFilterName = '';
      this.isDisabled = false;
      this.selectedResidentTypeCode = null;
      this.selectedNPNType = null;
      this.selectedContactList = [];
      this.selectedCarrierList = [];
      //this.selectedCarrierId = null;
      this.selectedLineOfBusinessCarrierId = null;

    }
  }

  closeDeletePopup() {
    this.isDeletePopup = false;
  }

  deleteFilter(selectedId) {
    //this.isDeletePopup = true;

    this.filterRequest.FilterId = selectedId;
    this.filterRequest.TenantId = this.tenantId;
    this.filterRequest.UserId = this.userId;


    this.filterService.deleteFilter(this.filterRequest).subscribe(
      (response) => {
        // Handle successful response
        if (response && response.id != null) {
          //if (selectedId === this.selectedFilter) {
          //  this.clearSelection();
          //}
          this.clearSelection();
          this.sharedService.showToastMessage("Filter deleted successfully.");          
          this.loadFilters("delete", null);
          
        }
        else {
          this.sharedService.showToastMessage(response.errorMessage);
        }
      },
      (error) => {
        // Handle error        
        if (error && error.message != undefined) {
          this.sharedService.showToastMessage(error.message);
        }
        else {
          this.sharedService.showToastMessage("Oops! Something went wrong. Please try again.");
        }
      }
    );
  }

  closePanel() {
    this.modalService.dismissAll();
    this.applyFilter(true);
  }

  onSaveFilterChange(currentFilter) {
    if (currentFilter != null && currentFilter != undefined && currentFilter.filterId != null) {
      this.selectedFilter = currentFilter.filterId;
    }

    if (this.selectedFilter != null && this.selectedFilter != undefined) {
      const filterData = this.filterList.find(obj => obj.filterId === this.selectedFilter);

      if (filterData != null && filterData != undefined && filterData.criteria != null) {
        this.selectedFilterName = filterData.name;

        if (filterData.ownerUserId != this.userId) {
          this.isDisabled = true;
        }
        else {
          this.isDisabled = false;
        }

        const criteria = JSON.parse(filterData.criteria);

        //Set selectedTags variable to bind tags dropdown
        if (criteria != undefined && criteria.tags != null) {
          const tagIdsArray: number[] = criteria.tags.split(',').map(id => parseInt(id.trim(), 10));

          this.selectedTags = [];
          tagIdsArray.forEach(id => {
            const foundTag = this.tags.find(tag => tag.tagId === id);
            if (foundTag) {
              this.selectedTags.push(foundTag);
            }
          });
        }

        if (this.filterCategory == this.filterCategoryProducer) {
          this.tenantStatusId = criteria.tenantStatusId;
          this.branchId = criteria.branchId;
          this.departmentId = criteria.departmentId;

          if (criteria.residentStates != null) {
            const residentStatesArray: number[] = criteria.residentStates.split(',').map(id => id);

            this.selectedResidentStates = [];
            residentStatesArray.forEach(id => {
              const foundState = this.residentStateList.find(state => state.stateCode === id);
              if (foundState) {
                this.selectedResidentStates.push(foundState);
              }
            });
          }
        }
        else {

          //Set selectedStates variable to bind state dropdown
          if (criteria != undefined && criteria.states != null) {
            const stateIdsArray: number[] = criteria.states.split(',').map(id => parseInt(id.trim(), 10));

            this.selectedStates = [];
            stateIdsArray.forEach(id => {
              const foundState = this.states.find(state => state.stateId === id);
              if (foundState) {
                this.selectedStates.push(foundState);
              }
            });
          }

          //Set selectedLicenseClasses variable to bind license class dropdown
          if (criteria != undefined && criteria.licenseClass != null) {
            const licenseClassCodesArray: string[] = criteria.licenseClass.split(',');

            this.selectedLicenseClasses = [];
            licenseClassCodesArray.forEach(code => {
              const foundlicenseClass = this.licenseClasses.find(licenseclass => licenseclass.licenseClassCode === code);
              if (foundlicenseClass) {
                this.selectedLicenseClasses.push(foundlicenseClass);
              }
            });
          }

          //Set selectedAppointmentTypeList variable to bind LOA dropdown
          if (criteria != undefined && criteria.appointmentTypes != null) {
            const appointmentTypeIdsArray: number[] = criteria.appointmentTypes.split(',').map(id => parseInt(id.trim(), 10));

            this.selectedAppointmentTypeList = [];
            appointmentTypeIdsArray.forEach(id => {
              const foundAppointmentTypeList = this.appointmentTypeList.find(appointmenttype => appointmenttype.appointmentTypeId === id);
              if (foundAppointmentTypeList) {
                this.selectedAppointmentTypeList.push(foundAppointmentTypeList);
              }
            });
          }
          // if(criteria != undefined && criteria.status != null && criteria.status != 0)
          // {
          this.selectedStatus = criteria.status == '' ? null : criteria.status;
          // }

          // if(criteria != undefined && criteria.branchId != null && criteria.branchId != 0)
          // {
          this.selectedBranchId = criteria.branchId;
          // }

          // if(criteria != undefined && criteria.expireIn != null && criteria.expireIn != 0)
          // {
          this.selectedExpireIn = criteria.expireIn;
          // }
          this.selectedResidentTypeCode = criteria.residentTypeCode;
          this.selectedNPNType = criteria.npnType;

          if (criteria.contactList != null) {
            const contactIdsArray: number[] = criteria.contactList.split(',').map(id => parseInt(id.trim(), 10));

            this.selectedContactList = [];
            contactIdsArray.forEach(id => {
              const foundContact = this.activeContactList.find(contact => contact.userId === id);
              if (foundContact) {
                this.selectedContactList.push(foundContact);
              }
            });
          }

          if (criteria.carrierList != null) {
            const carrierIdsArray: number[] = criteria.carrierList.split(',').map(id => parseInt(id.trim(), 10));

            this.selectedCarrierList = [];
            carrierIdsArray.forEach(id => {
              const foundCarrier = this.carrierList.find(carrier => carrier.carrierId === id);
              if (foundCarrier) {
                this.selectedCarrierList.push(foundCarrier);
              }
            });
          }
          //this.selectedCarrierId = criteria.carrierId;

          this.selectedLineOfBusinessCarrierId = criteria.lineOfBusinessCarrierId;
        }
      }
    }
  }

  @HostListener("click", ["$event"]) onClickDelete(event: any) {
    if (event.target.classList.contains('delete-item')) {
      event.preventDefault();
      this.deleteFilter(event.target.classList[0])
    }

  }

  scrolltoBottom(id) {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  ngAfterViewInit(){
   const dropdownId = document.getElementById('carrier');
   const dropdownList = dropdownId?.querySelectorAll('.multiselect-item-checkbox');
  //  const selectedList = dropdownId.querySelectorAll('.selected-item-container');
  
   dropdownList?.forEach(node => {
    let target = node?.querySelector('div');
    target.innerHTML = target?.innerHTML?.replace('★', 
      '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Contracted Carrier</title><path d="M9.27353 2.82493C9.55946 2.20503 10.4405 2.20503 10.7264 2.82493L12.5993 6.8854L17.0398 7.41189C17.7177 7.49227 17.99 8.33018 17.4888 8.79367L14.2058 11.8297L15.0773 16.2155C15.2103 16.8851 14.4976 17.403 13.9019 17.0695L9.99998 14.8854L6.09808 17.0695C5.50239 17.403 4.78962 16.8851 4.92266 16.2155L5.79413 11.8297L2.51116 8.79367C2.00996 8.33018 2.28221 7.49227 2.96013 7.41189L7.40062 6.8854L9.27353 2.82493Z" fill="#00A0F4"/> </svg>');
   
    let Input = node?.querySelector('input');
    Input.ariaLabel = Input.ariaLabel?.replace('★', '');
    });
  
  //  selectedList.forEach(node => {
  //   let target = node.querySelector('selected-item');
  //   target.innerHTML = target.innerHTML.replace('★', '');
   
  //   });

}
}

//function arraysEqual<T>(a: T[], b: T[]): boolean {
//  return a.length === b.length && a.every((value, index) => value === b[index]);
//}

function arraysEqual<T extends Record<string, any>>(a: T[], b: T[]): boolean {
  if (a.length !== b.length) return false;

  return a.every((obj, index) =>
    Object.keys(obj).every(
      key => obj[key] === b[index][key]
    )
  );
}

